import React from 'react';
import { gql, useQuery } from '@apollo/client';

import { NexoyaQuery, NexoyaQueryProvidersArgs } from '../../types/types';
import { useTeam } from '../../context/TeamProvider';
import { InitContext, InitCtx } from '../../context/InitProvider';

import auth from '../../Auth/Auth';
import { PROVIDER_CONNECTION_FRAGMENT, PROVIDER_META_FRAGMENT } from './fragments';

const PROVIDERS_QUERY = gql`
  query Providers($team_id: Int) {
    providers(team_id: $team_id) {
      ...providerMeta
      ...providerConnection
    }
  }
  ${PROVIDER_META_FRAGMENT}
  ${PROVIDER_CONNECTION_FRAGMENT}
`;

function useProvidersQuery() {
  const { teamId } = useTeam();
  // `token` is a render-time localStorage read, so it is only re-evaluated when something
  // re-renders this hook. On the /callback document it is empty at mount — `auth.login()` clears
  // the session before redirecting, and `setSession` writes it back later — so the query mounts
  // skipped. `loggedIn` flips right after the token is written (Callback and Authenticate both
  // call setAuthSuccess), which is what re-renders us to re-read it.
  const { loggedIn } = React.useContext<InitCtx>(InitContext);
  const token = auth.getAccessToken();
  const query = useQuery<Pick<NexoyaQuery, 'providers'>, NexoyaQueryProvidersArgs>(PROVIDERS_QUERY, {
    variables: {
      team_id: teamId || null,
    },
    skip: !loggedIn || !token || !teamId,
  });
  return query;
}

export { PROVIDERS_QUERY, useProvidersQuery };
